var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignInIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 7.30174C25.5 5.92893 26.8514 4.96423 28.1498 5.41023L38.3998 8.93124C39.2076 9.20873 39.75 9.9686 39.75 10.8227V37.1773C39.75 38.0314 39.2076 38.7913 38.3998 39.0688L28.1498 42.5898C26.8514 43.0358 25.5 42.0711 25.5 40.6983V7.30174Z",
    className: "iconBlue",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.25V12.5C11.25 11.3954 12.1454 10.5 13.25 10.5H25.5V37.5H13.25C12.1454 37.5 11.25 36.6046 11.25 35.5V30.75",
    className: "iconBlue",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1642 17.3358C16.3832 16.5547 15.1168 16.5547 14.3358 17.3358C13.5547 18.1168 13.5547 19.3832 14.3358 20.1642L17.1642 17.3358ZM21 24L22.4142 25.4142C22.7893 25.0391 23 24.5304 23 24C23 23.4696 22.7893 22.9609 22.4142 22.5858L21 24ZM14.3358 27.8358C13.5547 28.6168 13.5547 29.8832 14.3358 30.6642C15.1168 31.4453 16.3832 31.4453 17.1642 30.6642L14.3358 27.8358ZM14.3358 20.1642L19.5858 25.4142L22.4142 22.5858L17.1642 17.3358L14.3358 20.1642ZM19.5858 22.5858L14.3358 27.8358L17.1642 30.6642L22.4142 25.4142L19.5858 22.5858Z",
    className: "iconOrangeFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2501 24L8.25012 24",
    className: "iconOrange",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInIcon);
export default __webpack_public_path__ + "static/media/SignInIcon.d2e7d6c395d2e5dea0730641899cee34.svg";
export { ForwardRef as ReactComponent };